import type { ReactNode } from 'react'
import css from './Text.module.css'

interface TextMiddBoldProps {
    children: ReactNode
    className?: string
}

const TextMiddBold = ({ children, className }: TextMiddBoldProps) => {
    return <span className={[css.middBold, className].filter(Boolean).join(' ')}>{children}</span>
}

export default TextMiddBold
